import { Vue, Component } from 'nuxt-property-decorator';
import { DEFAULT_FEED_ROUTE, FEED_CATEGORIES_ROUTE, FEED_TOPICS_ROUTE } from '@/components/partials/war-room/constants';
import { DEFAULT_ACADEMY_ARTICLE_ROUTE } from '@/components/partials/academy/constants';
import Header from '~/components/global/Header/Header.vue';
import WarRoomCommissionTooltip from '~/components/partials/war-room/WarRoomCommissionTooltip/WarRoomCommissionTooltip.vue';
import TopNotification from '~/components/global/TopNotification/TopNotification.vue';
import BravadoTheme from '~/components/common/BravadoTheme/BravadoTheme.vue';
import { SEARCH_CATEGORY_PAGE, SEARCH_PAGE } from '~/constants/pages';

@Component({
  components: {
    Header,
    TopNotification,
    WarRoomCommissionTooltip,
    BravadoTheme,
    WarRoomMobileAppBannerTop: () =>
      import(
        '@/components/partials/war-room/WarRoomMobileAppBanner/WarRoomMobileAppBannerTop/WarRoomMobileAppBannerTop.vue'
      ),
    UserMenuMobile: () => import('@/components/global/UserMenuMobile/UserMenuMobile.vue'),
  },
})
export default class DefaultLayoutMixin extends Vue {
  errorCaptured(err: Error, vm: unknown, info: string) {
    this.$sentryUtils.error(err, info);
    return false;
  }

  // FIXME: The best way to modify layout from page is to pass props to vuex
  get isFooterVisible(): boolean {
    const excludedRoutes = [
      DEFAULT_FEED_ROUTE,
      FEED_CATEGORIES_ROUTE,
      FEED_TOPICS_ROUTE,
      DEFAULT_ACADEMY_ARTICLE_ROUTE,
      SEARCH_PAGE.name,
      SEARCH_CATEGORY_PAGE.name,
    ];
    return !excludedRoutes.includes(this.$route.name as string);
  }
}
